export const activityListSortTypes = Object.freeze({
  NEXT_ACTIVITY_DATE: 'next_activity_date',
  NAME: 'name',
  STATUS: 'status',
});
